import React, {
  forwardRef,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
} from 'react'

const asCursorManaged = ExtendedComponent => {
  const CursorManagedComponent = forwardRef(
    ({ onChange, value, ...props }, ref) => {
      const nodeRef = useRef(null)
      const cursorRef = useRef(null)

      useImperativeHandle(ref, () => ({
        inputRef: nodeRef,
        ref: nodeRef,
      }))

      useLayoutEffect(
        () => {
          const node = nodeRef.current
          const cursor = cursorRef.current
          if (node && cursor !== null && document.activeElement === node) {
            node.setSelectionRange(cursor, cursor)
          }
          cursorRef.current = null
        },
        [value]
      )

      const handleChange = (e, data) => {
        cursorRef.current = e.target.selectionStart
        if (onChange) onChange(e, data)
      }

      return (
        <ExtendedComponent
          {...props}
          value={value}
          onChange={handleChange}
          ref={nodeRef}
        />
      )
    }
  )

  CursorManagedComponent.displayName = `CursorManaged(${ExtendedComponent.displayName ||
    ExtendedComponent.name ||
    'Component'})`

  return CursorManagedComponent
}

export default asCursorManaged
